import moment from 'moment';

export const ENABLED_FLAGS = [
  'swipes_enabled',
  'banners_enabled',
  'thankyou_page_ads_enabled',
  'blog_reviews_enabled',
  'video_reviews_enabled',
  'social_media_posts_enabled',
  'logout_page_ads_enabled',
  'press_releases_enabled',
  'facebook_ads_enabled',
  'signatures_enabled',
];

// The API hands `created_at` back either as a raw timestamp or as a string it
// has already formatted for display. Parse the timestamps strictly and pass an
// already-formatted value straight through instead of letting moment guess.
const CREATED_AT_FORMATS = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DDTHH:mm:ss', moment.ISO_8601];

export function formatCreatedAt(value) {
  if (!value) {
    return '';
  }

  const parsed = moment(value, CREATED_AT_FORMATS, true);

  return parsed.isValid() ? parsed.format('D MMM, YYYY') : String(value);
}

export function promoAreaFacts(resource = {}, funnel = {}) {
  const pages = (funnel && funnel.main_product && funnel.main_product.affiliate_landing_pages) || [];
  const page = pages.find((p) => p.id == resource.landing_page_id);

  return {
    landingPageName: page ? page.description : '',
    createdAt: formatCreatedAt(resource.created_at),
    filledTypes: ENABLED_FLAGS.filter((k) => !!resource[k]).length,
    totalTypes: ENABLED_FLAGS.length,
  };
}

export default promoAreaFacts;
